// import React, { memo, useState } from "react";
// import { ReactComponent as Logo } from "../../../../../assets/svgs/sidebarlogo.svg";
// import {
//   FaFacebookF,
//   FaInstagram,
//   FaLinkedinIn,
//   FaYoutube,
//   FaGlobe,
// } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";

// const socialLinks = [
//   { href: "https://www.offsetgo.earth/", icon: FaGlobe, label: "Website" },
//   {
//     href: "https://www.facebook.com/OffsetGo/",
//     icon: FaFacebookF,
//     label: "Facebook",
//   },
//   {
//     href: "https://www.instagram.com/offsetgo.earth/",
//     icon: FaInstagram,
//     label: "Instagram",
//   },
//   { href: "https://x.com/offset_go", icon: FaXTwitter, label: "Twitter" },
//   {
//     href: "https://www.youtube.com/channel/UC5rh6a3k6bGTBbyLidQOWDg",
//     icon: FaYoutube,
//     label: "YouTube",
//   },
//   {
//     href: "https://www.linkedin.com/company/offset-go",
//     icon: FaLinkedinIn,
//     label: "LinkedIn",
//   },
// ];

// export default function Footer() {
//   const [email, setEmail] = useState("");

//   const SidebarLogo = memo(() => <Logo className="w-6 h-6 sm:w-8 sm:h-8" />);

//   const handleSubscribe = (e) => {
//     e.preventDefault();
//     if (email.trim()) {
//       console.log("Subscribe email:", email);
//       setEmail("");
//     }
//   };

//   const footerLinks = [
//     { href: "/about", label: "About Us" },
//     { href: "/contact", label: "Contact Us" },
//     { href: "/faq", label: "FAQ" },
//     { href: "/terms", label: "Terms" },
//     { href: "/privacy", label: "Privacy" },
//   ];

//   return (
//     <footer className="bg-white  text-[10px]">
//       <div className="w-full px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
//         {/* Left - Footer Links */}
//            <div className="flex flex-wrap justify-center gap-2 mt-2 mb-2 rounded-lg">
//           {socialLinks.map(({ href, icon: Icon, label }) => (
//             <a
//               key={label}
//               href={href}
//               target="_blank"
//               rel="noopener noreferrer"
//               aria-label={label}
//               className="text-[#fff]  text-sm bg-[#000000] p-1.5 rounded-full"
//             >
//               <Icon />
//             </a>
//           ))}
//         </div>
//         <div className="flex flex-wrap justify-start sm:justify-start gap-3 text-[#134A6A]">
//           {footerLinks.map(({ href, label }) => (
//             <a
//               key={label}
//               href={href}
//               className="hover:text-[#0087A3] transition text-[10px]"
//             >
//               {label}
//             </a>
//           ))}
//         </div>

//         {/* Center - Copyright */}
//         <div className="text-center text-gray-500 leading-tight text-[9px]">
//           Copyright © 2025 Version 2.3
//           <br />
//           Offset Global Technologies Private Limited.
//         </div>

//         {/* Right - Subscription */}
//         <div className="flex flex-col sm:items-end gap-1 text-[10px]">
//           <p className="text-gray-600 text-[10px] text-center sm:text-right">
//             Get the latest updates by subscribing you email
//           </p>
//           <form onSubmit={handleSubscribe} className="flex items-center gap-1">
//             <div className="flex overflow-hidden rounded-md border border-gray-300">
//               <input
//                 type="email"
//                 placeholder="Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 className="px-2 py-[6px] w-[120px] text-[10px] bg-[#E8F4F8] focus:outline-none"
//                 required
//               />
//               <button
//                 type="submit"
//                 className="px-3 py-[8px] text-[10px] bg-[#06513D] text-white hover:bg-teal-600 transition"
//               >
//                 Subscribe
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React, { memo, useState } from "react";
import PopupCard from "../../../../Auth/PopupCard";
import { postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { ReactComponent as Logo } from "../../../../../assets/svgs/sidebarlogo.svg";
import { ReactComponent as FooterBar } from "../../../../../assets/svgs/FooterLogo11.svg";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaGlobe,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const socialLinks = [
  { href: "https://www.offsetgo.earth/", icon: FaGlobe, label: "Website" },
  {
    href: "https://www.facebook.com/OffsetGo/",
    icon: FaFacebookF,
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/offsetgo.earth/",
    icon: FaInstagram,
    label: "Instagram",
  },
  { href: "https://x.com/offset_go", icon: FaXTwitter, label: "Twitter" },
  // {
  //   href: "https://www.youtube.com/channel/UC5rh6a3k6bGTBbyLidQOWDg",
  //   icon: FaYoutube,
  //   label: "YouTube",
  // },
  {
    href: "https://www.linkedin.com/company/offset-go",
    icon: FaLinkedinIn,
    label: "LinkedIn",
  },
];

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const SidebarLogo = memo(() => <Logo className="w-6 h-6 sm:w-8 sm:h-8" />);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (email.trim()) {
      setLoading(true);
      try {
        const response = await postApi({
          apiUrl: API_URLS.SUBSCRIBE_NEWSLETTER,
          data: { email: email.trim() },
        });

        const showPopupAndClose = (data) => {
          setPopupData(data);
          setTimeout(() => {
            setPopupData(null);
          }, 3000);
        };

        if (response.success) {
          const isAlreadySubscribed =
            response.message &&
            response.message.toLowerCase().includes("already");

          if (isAlreadySubscribed) {
            showPopupAndClose({
              type: "success",
              title: "Already Subscribed",
              message:
                "This email address is already subscribed. You'll continue receiving our latest updates.",
            });
          } else {
            showPopupAndClose({
              type: "success",
              title: "Subscription Successful",
              message:
                "Your subscription has been activated successfully. Thank you for joining our mailing list.",
            });
          }
          setEmail("");
        } else {
          showPopupAndClose({
            type: "error",
            title: "Error",
            message: response.message || "Subscription failed",
          });
        }
      } catch (error) {
        setPopupData({
          type: "error",
          title: "Error",
          message: "An error occurred. Please try again.",
        });
        setTimeout(() => setPopupData(null), 3000);
      } finally {
        setLoading(false);
      }
    }
  };

  const footerLinks = [
    { href: "/about", label: "About Us" },
    { href: "/contact", label: "Contact Us" },
    { href: "/faq", label: "FAQ" },
    { href: "/policies", label: "Terms" },
    { href: "/policies", label: "Privacy" },
  ];

  return (
    <footer className="bg-white  text-[10px]">
      <div className="w-full px-4 py-2 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
        {/* Left - Footer Links */}
        <div className="flex flex-wrap items-center justify-start sm:justify-start gap-2 text-[#134A6A]">
          <FooterBar className="block w-[150px] h-[60px] shrink-0" />
          <div className="flex flex-wrap justify-start sm:justify-start gap-3 text-[#134A6A]">
            {footerLinks.map(({ href, label }) => (
              <a
                key={label}
                href={href}
                className="hover:text-[#387464]  transition text-[10px]"
              >
                {label}
              </a>
            ))}
          </div>
        </div>

        {/* Center - Copyright and Social Icons */}
        <div className="text-center">
          <div className="flex flex-wrap justify-center gap-2 mt-2 mb-2 rounded-lg">
            {socialLinks.map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="text-[#fff] hover:!text-[#fff] text-xs bg-[#000000] p-1 rounded-full"
              >
                <Icon />
              </a>
            ))}
          </div>
          <div className="text-gray-500 leading-tight text-[10px]">
            Copyright © 2025 Version 2.3 Offset Global Technologies Private
            Limited.
          </div>
        </div>

        {/* Right - Subscription */}
        <div className="flex flex-col sm:items-end gap-1 text-[10px]">
          <p className="text-gray-600 text-[10px] text-center sm:text-right">
            Get the latest updates by subscribing you email
          </p>
          <form onSubmit={handleSubscribe} className="flex items-center gap-1">
            <div className="flex overflow-hidden rounded-md border border-gray-300">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="px-2 py-[6px] w-[120px] text-[10px] bg-[#E8F4F8] focus:outline-none"
                required
              />
              <button
                type="submit"
                disabled={loading}
                className={`px-3 py-[8px] text-[10px] bg-[#06513D] text-white transition ${loading ? "opacity-70 cursor-not-allowed" : "hover:bg-[#387464"}`}
              >
                {loading ? "..." : "Subscribe"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {popupData && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
            onConfirm={popupData.onConfirm}
            confirmText={popupData.confirmText}
            onCancel={popupData.onCancel}
            cancelText={popupData.cancelText}
          />
        </div>
      )}
    </footer>
  );
}
